<template>
  <div v-if="billing.subscription && billing.subscription.plan_type == plan_type" class="p-20">You are subscribed this plan already!</div>
  <div v-else class="p-20 max-full-width full-width-xs p-10-xs" style="width: 460px; margin: auto">
    <!-- No card -->
    <div v-if="!billing.card">
      <h4 class="strong">{{ $t("upgrade.enter_card_detail") }}</h4>
      <br />
      <Card ref="card" />
    </div>
    <!-- Has card already -->
    <div v-else>
      <UpdateCard :card="billing.card" @cardUpdated="$emit('cardUpdated')" />
    </div>
    <br />

    <!-- Number of members -->

    <h6 class="title mb-5">How many minutes of AI sales video do you need?</h6>
    <div class="range-slider-wrapper mb-20">
      <div class="slider-fixed"></div>
      <div class="slider-wrapper">
        <range-slider style="width: 100%" class="slider" :min="slider_min" :max="slider_max" step="1000" v-model="quantity"> </range-slider>
        <span class="range-label" :style="`left: ${((quantity - slider_min) / (slider_max - slider_min)) * 100}%`"
          >{{ quantity.toLocaleString("de-DE") }} min</span
        >
      </div>
    </div>

    <!-- Billling address details -->
    <div class="mb-20">
      <div class="flex items-center" v-if="show_business_toggle">
        <h6 class="mb-0">I'm purchasing as a business</h6>
        <div class="flex-1"></div>
        <Switcher
          :value="show_billing_details"
          :fat="true"
          @input="
            (value) => {
              show_billing_details = value;
            }
          " />
      </div>
      <BillingTax
        class="font-body mt-10 p-15 div-border border-radius-4"
        :class="{ hide: !show_billing_details }"
        @added="
          show_business_toggle = false;
          calculate();
        "
        @removed="
          show_business_toggle = true;
          show_billing_details = false;
          calculate();
        " />
    </div>

    <!-- Discount code -->
    <div class="mb-20">
      <div class="flex items-center">
        <h6 class="mb-0">I have coupon <i class="la la-tag"></i></h6>
        <div class="flex-1"></div>
        <Switcher :value="show_coupon" :fat="true" @input="toggleCoupon" />
      </div>

      <div class="flex items-center mt-10 div-border border-radius-4 p-10" :class="{ hide: !show_coupon }">
        <input class="font-h6 flex-1 no-border" type="text" placeholder="DISCOUNT CODE" maxlength="30" v-model="coupon_code" @input="inputCoupon" />
        <span
          v-if="coupon_status == 'valid'"
          class="color-white color-white-darkmode bg-green border-radius px-5 sm-text ml-10 inline-flex items-center"
          style="height: 18px"
          >VALID</span
        >
        <span
          v-else-if="coupon_status == 'invalid'"
          class="color-white color-white-darkmode bg-lip border-radius px-5 sm-text ml-10 inline-flex items-center"
          style="height: 18px"
          >INVALID</span
        >
        <i v-else-if="coupon_status == 'loading'" class="la la-spinner spinning color-primary font-h5s ml-10"></i>
      </div>

      <p class="sm-text color-green align-right mt-5" v-if="the_price.discount != ''">
        You will get {{ the_price.discount }} of discount {{ the_price.duration_off == "forever" ? "forever" : "" }} on Weezly
      </p>
    </div>

    <!-- PAY button -->
    <button v-if="!billing.suscription" class="btn btn-primary py-15 free-height block strong font-h4" :class="{ disabled: loading_price }" @click="submit">
      <i v-if="!loading" class="la la-flag-checkered mr-10"></i>
      <i v-else class="la la-spinner spinning mr-10"></i>
      <span class="uppercase mr-10">{{ $t("upgrade.PAY") }}</span>
      {{ loading_price ? ".." : `$${the_price.total}` }}
    </button>

    <!-- UPGRADE button -->
    <!-- <button v-else class="btn btn-primary py-15 free-height block strong font-h4" @click="upgrade">
      <i v-if="!loading" class="la la-crown mr-10"></i>
      <i v-else class="la la-spinner spinning mr-10"></i>
      <span class="uppercase mr-10">CHANGE PLAN</span>
    </button> -->

    <div class="align-center mt-10 color-lightgray flex items-center">
      {{ $t("upgrade.payment_managed_by") }}:
      <img src="@/assets/img/icons/stripe.png" alt="Stripe" height="18px" class="ml-5" />
    </div>

    <div class="align-right font-body mt-10" v-if="loading_price">
      <div class="inline-flex items-center">
        <span>{{ $t("upgrade.total_cost") }}:</span>
        <i class="la la-spinner spinning color-primary ml-5 font-h5"></i>
      </div>
    </div>
    <div class="align-right font-body mt-10" v-else-if="the_plan.billed == 'monthly'">
      {{ $t("upgrade.total_cost") }}: <strong>${{ the_price.price }}</strong>

      <strong v-if="the_price.discount != ''" class="color-green"> - {{ the_price.discount }} (discount)</strong>

      + <strong>VAT({{ the_price.vat }}%)</strong> =
      <strong>${{ the_price.total }}</strong>
    </div>
    <div class="align-right font-body mt-10" v-else-if="the_plan.billed == 'yearly'">
      {{ $t("upgrade.total_cost") }}: <strong>12 months</strong> x
      <strong>${{ Math.round(the_price.price / 12) }}</strong>
      <strong v-if="the_price.discount != ''" class="color-green"> - {{ the_price.discount }} (discount)</strong>
      + <strong>VAT({{ the_price.vat }}%)</strong> =
      <strong>${{ the_price.total }}</strong>
    </div>
  </div>
</template>

<script>
import request from "@/service";
import Card from "@/components/Upgrade/Card";
import UpdateCard from "@/components/Upgrade/UpdateCard";
import BillingTax from "./BillingTax";

import RangeSlider from "vue-range-slider";
import "vue-range-slider/dist/vue-range-slider.css";
export default {
  name: "Payment",
  components: {
    Card,
    UpdateCard,
    BillingTax,
    RangeSlider,
  },
  props: {
    plan_type: {
      type: String,
      default: "",
    },
    billing: Object,
  },
  data: function () {
    return {
      loading: false,
      quantity: 1000,
      percent: 0,

      loading_price: false,
      show_business_toggle: false,
      show_billing_details: false,

      show_coupon: false,
      coupon_code: "",
      coupon_status: "",
      coupon_timeout: false,
      coupon_key: 0,

      percent_off: 0,
      amount_off: 0,
      duration_off: "",

      slider_min: 1000,
      slider_max: 50000,
    };
  },
  async mounted() {
    if (this.plan_type == "agency_monthly") this.quantity = 20000;
    else this.quantity = 1000;
  },
  computed: {
    me() {
      return this.$store.getters.getMe;
    },
    the_plan() {
      let p = this.billing.packages.find((p) => p.plan_type == this.plan_type);
      if (p) {
        if (this.coupon_code) this.inputCoupon();

        if (p.plan_type == "agency_monthly") {
          this.slider_min = 20000;
          this.slider_max = 100000;
          this.quantity = 20000;
        } else {
          this.slider_min = 1000;
          this.slider_max = 50000;
          this.quantity = 1000;
        }

        return p;
      }
      return {};
    },
    the_price() {
      let price = {
        price: "..",
        vat: this.percent,
        total: "..",
        discount: "",
        duration_off: this.duration_off,
      };

      if (this.the_plan.plan_price) {
        let prices = this.the_plan.plan_price.split("/");
        let price_first = parseFloat(prices[0]);
        let price_rest = parseFloat(prices[1]);
        let quantity = this.quantity;

        let min = this.the_plan.minimum_seats;
        let total_first = price_first * min;
        let total_rest = (quantity - min) * price_rest;
        let p = total_first + total_rest;

        price.price = p;

        if (this.percent_off) {
          price.discount = this.percent_off + "%";
          let discount = (p * this.percent_off) / 100;
          p = p - discount;
        } else if (this.amount_off) {
          price.discount = "$" + this.amount_off;
          p = p - this.amount_off;
        }
        if (p < 0) p = 0;

        let vat_price = (p * this.percent) / 100;
        let total = p + vat_price;

        price.total = Math.round(total * 100) / 100;
      }

      return price;
    },
  },
  methods: {
    focus() {
      if (this.$refs.card) this.$refs.card.focus();
    },
    async submit() {
      if (this.loading | this.loading_price | (this.coupon_status == "loading")) return false;

      this.loading = true;

      if (this.$refs.card) {
        const token = await this.$refs.card.createToken();
        if (!token) {
          this.loading = false;
          return false;
        }

        // Step 1: Create payment method AND stripe customer
        const responsePayment = await request("POST", "stripe/addPaymentMethod", {
          token: token,
        });

        if (!responsePayment) {
          this.$root.$emit("alert", this.$t("upgrade.something_wrong"), "error");
          this.loading = false;
          return false;
        }
      }

      let quantity = this.quantity;

      // Step 2: Create a subscription
      let subscribe = await request("POST", "stripe/subscribe", {
        quantity: quantity,
        plan_type: this.plan_type,
        coupon_code: this.coupon_code != "" && this.coupon_status == "valid" ? this.coupon_code : null,
      });

      // Step 3: Confirm payment
      if (subscribe) {
        const { error } = await this.$stripe.confirmPayment({
          clientSecret: subscribe.data.clientSecret,
          confirmParams: {
            return_url: window.location.origin + "/upgrade?state=success",
          },
        });
      }
      this.loading = false;
    },
    async upgrade() {
      if (this.loading) return false;

      this.loading = true;

      // Step 1: Subscribe new subscription
      let subscribe = await request("POST", "stripe/changePlan", {
        plan_type: this.plan_type,
      });

      // Step 2: Confirm payment
      if (subscribe) {
        if (subscribe.data.status == "succeeded") {
          window.location.href =
            window.location.origin + "/upgrade?payment_intent=" + subscribe.data.paymentIntent + "&payment_intent_client_secret=" + subscribe.data.clientSecret;
        } else {
          const { error } = await this.$stripe.confirmPayment({
            clientSecret: subscribe.data.clientSecret,
            confirmParams: {
              return_url: window.location.origin + "/upgrade?state=success",
            },
          });
        }
      }
    },
    async calculate() {
      this.loading_price = true;
      const response = await request("POST", "stripe/calculateTax", {
        plan_type: this.plan_type,
        quantity: this.quantity,
      });

      if (response) {
        this.percent = response.data.percentage;

        if (!this.show_billing_details) {
          const billing_details = await request("GET", "stripe/getBillingDetails");
          if (billing_details && billing_details.data) this.show_business_toggle = false;
          else this.show_business_toggle = true;
        }

        if (this.billing.blackfriday) {
          if (this.plan_type == "growth_monthly") {
            this.show_coupon = true;
            this.coupon_code = this.billing.blackfriday;
            await this.inputCoupon();
          } else if (this.coupon_code == this.billing.blackfriday) {
            this.show_coupon = false;
            this.coupon_code = "";
            await this.inputCoupon();
          }
        }

        this.loading_price = false;
      } else {
        this.$root.$emit("alert", "Could not calculate the price!", "error");
      }
    },
    toggleCoupon(value) {
      this.show_coupon = value;
      clearTimeout(this.coupon_timeout);
      this.percent_off = 0;
      this.amount_off = 0;
      this.duration_off = "";
      this.coupon_status = "";
      this.coupon_code = "";
    },
    async inputCoupon() {
      clearTimeout(this.coupon_timeout);
      let coupon_code = this.coupon_code.trim();

      this.percent_off = 0;
      this.amount_off = 0;
      this.duration_off = "";

      if (coupon_code == "") {
        this.coupon_status = "";
      } else {
        this.coupon_status = "loading";

        this.coupon_timeout = setTimeout(async () => {
          const response = await request("POST", "stripe/checkCouponStatus", {
            coupon_code: coupon_code,
            plan_type: this.plan_type,
          });

          if (!this.show_coupon) return false;

          if (!response && coupon_code == this.coupon_code.trim()) {
            this.coupon_status = "invalid";
          } else if (response && response.data.coupon_code == this.coupon_code.trim()) {
            let coupon_data = response.data;
            if (coupon_data.status == "valid") {
              this.coupon_status = "valid";
              this.percent_off = parseInt(coupon_data.percent_off);
              this.amount_off = parseInt(coupon_data.amount_off) / 100;
              this.duration_off = coupon_data.duration_off;
            } else {
              this.coupon_status = "invalid";
            }
          }
        }, 1000);
      }
    },
  },
};
</script>
